<template>
  <nav>
    <div class="container nav-height space-between align-items-center">
      <router-link
        class="color-primary bold"
        to="/"
      >
        Lennart Hakker
      </router-link>  
      <ul>
        <li class="mr-16">
          <router-link
            class="color-primary bold"
            to="/about"
          >
            About
          </router-link>
        </li>
        <li class="align-items-center">
          <select 
            class="color-primary bold mr-8 border-0"
            v-model="locale"
          >
            <option value="en">EN</option>
            <option value="nl">NL</option>
          </select>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 8.97106C18 3.99357 13.9935 0 9 0C4.00645 0 0 3.99357 0 8.97106C0 11.6913 1.21935 14.0643 3.07742 15.7428L3.19355 15.9743C3.19355 15.9743 3.25161 15.9743 3.25161 15.9164C4.81935 17.1897 6.79355 18 9 18C13.5871 18 17.3613 14.5852 17.9419 10.1286H18V8.97106ZM16.8968 8.97106H14.1097C14.1097 7.2926 13.8774 5.7299 13.4129 4.39871C13.471 4.34084 13.529 4.34084 13.5871 4.28296C13.7032 4.22508 14.2839 3.87781 14.4 3.76206C14.5161 3.70418 14.6323 3.6463 14.7484 3.53055C16.0839 4.97749 16.8968 6.88746 16.8968 8.97106ZM13.3548 14.8746C13.529 14.9904 13.7032 15.1061 13.8774 15.164C13.2968 15.5691 12.7161 15.9743 12.0194 16.2058C12.3677 15.7428 12.7161 15.2219 12.9484 14.6431C13.0645 14.701 13.2387 14.8167 13.3548 14.8746ZM5.16774 14.8167C5.4 15.3376 5.69032 15.8006 6.03871 16.2058C5.45806 15.9743 4.87742 15.627 4.4129 15.2797C4.64516 15.164 4.99355 14.9325 5.10968 14.8746C5.10968 14.8746 5.10968 14.8167 5.16774 14.8167ZM5.05161 8.97106C5.05161 7.52412 5.28387 6.13505 5.63226 4.97749C6.50323 5.26688 7.43226 5.44051 8.41935 5.44051V8.97106H5.05161ZM4.70323 3.35691C4.4129 3.18328 4.18064 3.06752 4.00645 2.89389C4.5871 2.37299 5.28387 1.96785 6.03871 1.67846C5.63226 2.19936 5.28387 2.83601 4.99355 3.47267C4.87742 3.47267 4.76129 3.41479 4.70323 3.35691ZM12.9484 3.29904C12.6581 2.66238 12.3677 2.14148 11.9613 1.67846C12.6581 1.96785 13.2387 2.31511 13.8194 2.77814C13.8194 2.77814 13.7613 2.77814 13.7613 2.83601C13.6452 2.89389 13.1226 3.24116 12.9484 3.29904ZM9.58064 1.21543C10.5097 1.50482 11.3806 2.43087 11.9613 3.81994C11.2645 4.10932 10.5677 4.22508 9.58064 4.28296V1.21543ZM8.41935 1.21543V4.34084C7.54839 4.34084 6.73548 4.1672 5.98065 3.93569C6.61935 2.48875 7.49032 1.50482 8.41935 1.21543ZM8.41935 10.0707V12.7331C7.31613 12.791 6.50323 12.9646 5.69032 13.254C5.4 12.328 5.16774 11.2283 5.05161 10.0707H8.41935ZM8.41935 13.8907V16.7267C7.54839 16.4373 6.73548 15.5691 6.15484 14.3537C6.79355 14.0643 7.49032 13.9486 8.41935 13.8907ZM9.58064 16.7267V13.8907C10.3935 13.8907 11.2065 14.0064 11.9032 14.2379C11.2645 15.5691 10.4516 16.4373 9.58064 16.7267ZM9.58064 12.7331V10.0707H12.8903C12.8323 11.2283 12.6 12.2701 12.3097 13.1961C11.4387 12.9068 10.5677 12.791 9.58064 12.7331ZM9.58064 8.97106V5.44051C10.7419 5.38264 11.5548 5.209 12.3677 4.91961C12.7161 6.13505 12.9484 7.52412 12.9484 9.02894H9.58064V8.97106ZM3.19355 3.70418C3.48387 3.87781 3.77419 4.10932 4.18064 4.34084C4.29677 4.39871 4.4129 4.45659 4.5871 4.57235C4.18064 5.90354 3.94839 7.40836 3.94839 8.97106H1.10323C1.10323 6.94534 1.91613 5.09325 3.19355 3.70418ZM1.21935 10.0707H4.00645C4.06452 11.4598 4.35484 12.6752 4.70323 13.7749C4.64516 13.8328 4.52903 13.8907 4.47097 13.8907C4.35484 13.9486 3.77419 14.2958 3.65806 14.4116C3.6 14.4695 3.54194 14.4695 3.42581 14.5273C2.26452 13.3698 1.45161 11.8071 1.21935 10.0707ZM14.6903 14.4116C14.4581 14.2379 14.1677 14.0643 13.8774 13.8907C13.7032 13.7749 13.529 13.717 13.3548 13.6013C13.7032 12.5595 13.9355 11.3441 14.0516 10.0707H16.8387C16.5484 11.7492 15.7935 13.254 14.6903 14.4116Z" fill="#8595F8"/>
          </svg>
        </li>
      </ul>  
    </div>
  </nav>
  <div class="nav-height"/>
</template>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'nav',
    data () { 
      return { 
        locale: 'en',
      };
    },
    watch: {
      locale (val) {
        this.$i18n.locale = val
      }
    },
  });
</script>